/**
 * Message signature verification result.
 */
export default class MoneroMessageSignatureResult {
    constructor(result) {
        Object.assign(this, result);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getIsGood() {
        return this.isGood;
    }
    setIsGood(isGood) {
        this.isGood = isGood;
        return this;
    }
    getIsOld() {
        return this.isOld;
    }
    setIsOld(isOld) {
        this.isOld = isOld;
        return this;
    }
    getSignatureType() {
        return this.signatureType;
    }
    setSignatureType(signatureType) {
        this.signatureType = signatureType;
        return this;
    }
    getVersion() {
        return this.version;
    }
    setVersion(version) {
        this.version = version;
        return this;
    }
}
